import * as React from 'react';

import { Row, Form, Switch } from 'antd';
import { Input, InputNumber, Notification, Space, Text } from 'farmhub-ui-core';
import { useHistory } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app';
import { Footer, PageTitleBar } from 'components';
import MainContent from 'components/Layout/MainContent';
import { createEntityLarkBase } from 'slice';
import { theme } from 'styled';

import LarkAppSelect from '../../ConnectLarkPage/components/LarkSelect';

type CreateBodyProps = {
  entityLarkAppID: string;
  name: string;
  baseID?: number;
  stockTableID: number;
  entityProductTableID: number;
  inputTableID: number;
  outputTableID: number;
  larkBotURL: string;
  minStockQuantity: number;
  isEnabledNotifyOutOfStock: boolean;
};

export const EntityStockReportCreatePage = (): JSX.Element => {
  const [form] = Form.useForm();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const entityID = useAppSelector(state => state.account.item?.id);
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleSubmitBodyCreate = () => {
    if (entityID) {
      form.validateFields().then(async values => {
        setIsSubmitting(true);

        console.log(values);

        const createBody: CreateBodyProps = {
          entityLarkAppID: values.entityLarkAppID,
          name: values.name,
          baseID: values.baseID,
          stockTableID: values.stockTableID,
          entityProductTableID: values.entityProductTableID,
          inputTableID: values.inputTableID,
          outputTableID: values.outputTableID,
          larkBotURL: values.larkBotURL,
          minStockQuantity: values.minStockQuantity,
          isEnabledNotifyOutOfStock: values.isEnabledNotifyOutOfStock,
        };

        try {
          await dispatch(createEntityLarkBase(createBody)).unwrap();

          history.push(`/settings/stock-report/list`);
        } catch (error: any) {
          Notification('error', 'Tạo báo cáo thất bại', error);
        } finally {
          setIsSubmitting(false);
        }
      });
    }
  };

  const handleChangeLarkApp = async (val: any) => {
    form.setFieldsValue({ entityLarkAppID: val });
  };

  const handleCreateNewLarkApp = () => {
    // create new lark app
    history.push('/settings/stock-report/connect/create');
  };

  return (
    <Form form={form}>
      <MainContent hasFooter>
        <PageTitleBar title="Thêm mới báo cáo tồn kho" />
        <Space height={25} />
        <Text
          color="dark"
          size="xxs"
          textTransform="uppercase"
          weight="extraBold"
        >
          Thông tin cơ bản
        </Text>
        <Space height={15} />
        <Form
          form={form}
          labelAlign="left"
          labelCol={{ span: 6 }}
          layout="horizontal"
          wrapperCol={{ span: 11 }}
        >
          <Form.Item
            label="Tiều đề"
            name="name"
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập tiêu đề',
              },
            ]}
          >
            <Input
              height={theme.input.height.md}
              placeholder="Nhập tiêu đề tại đây"
            />
          </Form.Item>
          <Form.Item
            label="Ứng dụng Lark:"
            name="entityLarkAppID"
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập chọn ứng dụng Lark',
              },
            ]}
          >
            <LarkAppSelect
              entityID={entityID}
              onAddLarkApp={handleCreateNewLarkApp}
              onSelect={handleChangeLarkApp}
            />
          </Form.Item>

          <Form.Item
            label="ID LarkBase"
            name="baseID"
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập ID LarkBase',
              },
            ]}
          >
            <Input
              height={theme.input.height.md}
              placeholder="Nhâp ID LarkBase tại đây"
            />
          </Form.Item>
          <Form.Item
            label="Thông tin ID bảng"
            name="tableID"
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập thông tin các ID bảng!',
              },
            ]}
          >
            <Row
              justify="space-between"
              style={{ width: '100%', gap: 6, flexWrap: 'nowrap' }}
            >
              <Form.Item
                name="stockTableID"
                rules={[
                  {
                    required: true,
                    message: 'Bạn chưa nhập thông tin!',
                  },
                ]}
                style={{ marginBottom: '0px', width: '25%' }}
              >
                <Input
                  height={theme.input.height.md}
                  placeholder="ID bảng tồn kho"
                  width="100%"
                />
              </Form.Item>
              <Form.Item
                name="entityProductTableID"
                rules={[
                  {
                    required: true,
                    message: 'Bạn chưa nhập thông tin!',
                  },
                ]}
                style={{ marginBottom: '0px', width: '25%' }}
              >
                <Input
                  height={theme.input.height.md}
                  placeholder="ID bảng sản phẩm"
                  width="100%"
                />
              </Form.Item>
              <Form.Item
                name="inputTableID"
                rules={[
                  {
                    required: true,
                    message: 'Bạn chưa nhập thông tin!',
                  },
                ]}
                style={{ marginBottom: '0px', width: '25%' }}
              >
                <Input
                  height={theme.input.height.md}
                  placeholder="ID bảng nhập kho"
                  width="100%"
                />
              </Form.Item>
              <Form.Item
                name="outputTableID"
                rules={[
                  {
                    required: true,
                    message: 'Bạn chưa nhập thông tin!',
                  },
                ]}
                style={{ marginBottom: '0px', width: '25%' }}
              >
                <Input
                  height={theme.input.height.md}
                  placeholder="ID bảng xuất kho"
                  width="100%"
                />
              </Form.Item>
            </Row>
          </Form.Item>

          <Form.Item
            label="Thông báo Lark URL"
            name="larkBotURL"
            rules={[
              {
                message: 'Bạn chưa nhập thông báo Lark URL',
              },
            ]}
          >
            <Input
              height={theme.input.height.md}
              placeholder="Nhâp đường dẫn URL tại đây"
            />
          </Form.Item>
          <Form.Item
            label="Giá trị dưới định mức"
            name="minStockQuantity"
            rules={[
              {
                type: 'number',
                message: 'Bạn chưa nhập giá trị dưới định mức',
              },
            ]}
          >
            <InputNumber
              defaultValue={100}
              height={theme.input.height.md}
              min={1}
              placeholder="Nhập giá trị dưới định mức"
              width="100%"
            />
          </Form.Item>
          <Form.Item
            label="Thông báo khi dưới định mức"
            name="isEnabledNotifyOutOfStock"
            style={{ marginBottom: '0px' }}
          >
            <Switch />
          </Form.Item>
        </Form>
      </MainContent>
      <Footer
        content={['Hủy thêm mới', 'Hoàn thành']}
        isSubmitting={isSubmitting}
        onSubmit={handleSubmitBodyCreate}
      />
    </Form>
  );
};
